(function () {
  'use strict';

  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));
  const locale = String(document.documentElement.lang || 'ar').toLowerCase();
  const isEnglish = locale.indexOf('en') === 0;
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const localizedRoot = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';

  const ui = isEnglish ? {
    adding: 'Adding...',
    added: 'Product added to cart',
    addError: 'Unable to add product',
    addToCart: 'Add to Cart',
    emptyCart: 'Your cart is empty',
    emptyCartHelp: 'Browse Herbal Vitaly products to get started.',
    shopNow: 'Shop Now',
    total: 'Total',
    checkout: 'Checkout',
    viewCart: 'View Cart',
    codNotice: 'Cash on delivery is available in Egypt.',
    cartLoadError: 'Unable to load cart.',
    productLoading: 'Loading product...',
    viewDetails: 'View Details',
    productLoadError: 'Unable to load product.',
    quantity: 'Quantity',
    decreaseQuantity: 'Decrease quantity',
    increaseQuantity: 'Increase quantity'
  } : {
    adding: 'جارٍ الإضافة...',
    added: 'تمت إضافة المنتج إلى السلة',
    addError: 'تعذر إضافة المنتج',
    addToCart: 'أضف إلى السلة',
    emptyCart: 'سلتك فارغة',
    emptyCartHelp: 'ابدأ بتصفح منتجات Herbal Vitaly.',
    shopNow: 'تسوق الآن',
    total: 'الإجمالي',
    checkout: 'إتمام الطلب',
    viewCart: 'عرض السلة',
    codNotice: 'الدفع عند الاستلام متاح داخل مصر.',
    cartLoadError: 'تعذر تحميل السلة.',
    productLoading: 'جارٍ تحميل المنتج...',
    viewDetails: 'عرض التفاصيل',
    productLoadError: 'تعذر تحميل المنتج.',
    quantity: 'الكمية',
    decreaseQuantity: 'تقليل الكمية',
    increaseQuantity: 'زيادة الكمية'
  };

  if (locale === 'fr' && window.HVFrenchUI) Object.assign(ui, window.HVFrenchUI);

  const formatMoney = (amount) => {
    try {
      return (amount / 100).toLocaleString(locale === 'fr' ? 'fr-FR' : (isEnglish ? 'en' : 'ar-EG'), {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EGP'
      });
    } catch (error) {
      return (amount / 100).toFixed(2) + ' EGP';
    }
  };

  const toast = (message) => {
    const el = qs('[data-toast]');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(window.__hvToast);
    window.__hvToast = setTimeout(() => { el.hidden = true; }, 2800);
  };

  document.addEventListener('change', function (event) {
    const selector = event.target.closest('[data-language-selector], [data-country-selector]');
    if (selector && selector.form) selector.form.submit();
  });

  document.addEventListener('click', async function (event) {
    const menuToggle = event.target.closest('[data-mobile-toggle]');
    if (menuToggle) {
      event.preventDefault();
      document.body.classList.add('mobile-open');
      document.documentElement.classList.add('mobile-open');
      const drawer = qs('.hv2-mobile-drawer');
      if (drawer) drawer.setAttribute('aria-hidden', 'false');
      menuToggle.setAttribute('aria-expanded', 'true');
      return;
    }

    if (event.target.closest('[data-mobile-close]')) {
      document.body.classList.remove('mobile-open');
      document.documentElement.classList.remove('mobile-open');
      const drawer = qs('.hv2-mobile-drawer');
      if (drawer) drawer.setAttribute('aria-hidden', 'true');
      qsa('[data-mobile-toggle]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      return;
    }

    if (event.target.closest('[data-search-toggle]')) {
      const searchBar = qs('[data-search-bar]');
      if (searchBar) {
        searchBar.hidden = !searchBar.hidden;
        const input = searchBar.querySelector('input');
        if (!searchBar.hidden && input) input.focus();
      }
      return;
    }

    if (event.target.closest('[data-cart-open]')) {
      if (qs('#HVCartDrawer')) {
        event.preventDefault();
        await openCartDrawer();
      }
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      closeCartDrawer();
      return;
    }

    const quickView = event.target.closest('[data-quick-view]');
    if (quickView) {
      event.preventDefault();
      openQuickView(quickView.dataset.quickView);
      return;
    }

    if (event.target.closest('[data-close-modal]')) {
      closeQuickView();
      return;
    }

    const qtyButton = event.target.closest('[data-qty-button]');
    if (qtyButton) {
      const input = qtyButton.closest('.quantity')?.querySelector('input');
      if (input) {
        let value = parseInt(input.value || '1', 10);
        value += qtyButton.dataset.qtyButton === 'plus' ? 1 : -1;
        input.value = Math.max(1, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('form[data-product-form]');
    if (!form) return;

    event.preventDefault();
    const body = new FormData(form);
    const button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = true;
      button.dataset.oldText = button.textContent;
      button.textContent = ui.adding;
    }

    try {
      const response = await fetch(localizedRoot + 'cart/add.js', {
        method: 'POST',
        body,
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw await response.json();
      await refreshCartCount();
      toast(ui.added);
      await openCartDrawer();
    } catch (error) {
      toast((error && error.description) || ui.addError);
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.oldText || ui.addToCart;
      }
    }
  });

  qsa('[data-gallery-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
    const main = qs('[data-gallery-main]');
    if (!main) return;
    main.src = thumb.dataset.image;
    main.srcset = thumb.dataset.srcset || '';
    qsa('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }));

  qsa('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const price = qs('[data-product-price]');
    const addButton = qs('[data-main-atc]');
    const variantId = qs('[data-variant-id]');
    if (variantId) variantId.value = select.value;
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (addButton) addButton.disabled = option.dataset.available === 'false';
  }));

  async function refreshCartCount() {
    try {
      const cart = await (await fetch(localizedRoot + 'cart.js')).json();
      qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    } catch (error) {}
  }

  async function openCartDrawer() {
    const drawer = qs('#HVCartDrawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    await renderCartDrawer();
  }

  function closeCartDrawer() {
    const drawer = qs('#HVCartDrawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    }
  }

  async function renderCartDrawer() {
    const target = qs('[data-cart-drawer-body]');
    if (!target) return;
    try {
      const cart = await (await fetch(localizedRoot + 'cart.js')).json();
      if (!cart.items.length) {
        target.innerHTML = '<div class="empty-state"><h3>' + escapeHtml(ui.emptyCart) + '</h3><p class="muted">' + escapeHtml(ui.emptyCartHelp) + '</p><a class="btn" href="' + escapeHtml(localizedRoot + 'collections/all') + '">' + escapeHtml(ui.shopNow) + '</a></div>';
        return;
      }

      target.innerHTML = cart.items.map((item) => '<div class="drawer-item"><img src="' + escapeHtml(item.image || '') + '" alt="' + escapeHtml(item.product_title) + '"><div><h4>' + escapeHtml(item.product_title) + '</h4><p class="muted">' + item.quantity + ' × ' + formatMoney(item.final_price) + '</p></div></div>').join('')
        + '<div class="drawer-footer"><div class="drawer-total"><span>' + escapeHtml(ui.total) + '</span><span>' + formatMoney(cart.total_price) + '</span></div><a class="btn btn--full" href="' + escapeHtml(locale === 'fr' ? localizedRoot + 'checkout' : '/checkout') + '">' + escapeHtml(ui.checkout) + '</a><a class="btn btn--secondary btn--full" href="' + escapeHtml(localizedRoot + 'cart') + '">' + escapeHtml(ui.viewCart) + '</a><p class="muted">' + escapeHtml(ui.codNotice) + '</p></div>';
    } catch (error) {
      target.innerHTML = '<p class="muted">' + escapeHtml(ui.cartLoadError) + '</p>';
    }
  }

  async function openQuickView(handle) {
    const modal = qs('#HVQuickView');
    const target = qs('[data-quick-view-content]');
    if (!modal || !target || !handle) return;

    target.innerHTML = '<p class="muted">' + escapeHtml(ui.productLoading) + '</p>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    try {
      const product = await (await fetch(localizedRoot + 'products/' + encodeURIComponent(handle) + '.js')).json();
      const variant = product.variants.find((item) => item.available) || product.variants[0];
      const detailUrl = localizedRoot + 'products/' + encodeURIComponent(handle);
      target.innerHTML = '<div class="quick-view"><div class="quick-view__image"><img src="' + escapeHtml(product.featured_image || '') + '" alt="' + escapeHtml(product.title) + '"></div><div><span class="badge">Herbal Vitaly</span><h2>' + escapeHtml(product.title) + '</h2><div class="price">' + formatMoney(variant.price) + '</div><p class="muted">' + escapeHtml(stripHtml(product.description).slice(0, 220)) + '...</p><form data-product-form><input type="hidden" name="id" value="' + variant.id + '"><input type="hidden" name="quantity" value="1"><button class="btn" type="submit">' + escapeHtml(ui.addToCart) + '</button><a class="btn btn--secondary" href="' + escapeHtml(detailUrl) + '">' + escapeHtml(ui.viewDetails) + '</a></form></div></div>';
    } catch (error) {
      target.innerHTML = '<p class="muted">' + escapeHtml(ui.productLoadError) + '</p>';
    }
  }

  function closeQuickView() {
    const modal = qs('#HVQuickView');
    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
    }
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  refreshCartCount();
})();

document.addEventListener('change', function (event) {
  if (event.target.matches('.hv2-language__select')) event.target.closest('form').submit();
});

(function () {
  function applyQuantityAccessibility() {
    const isEnglish = String(document.documentElement.lang || 'ar').toLowerCase().indexOf('en') === 0;
    const labels = isEnglish
      ? { quantity: 'Quantity', decrease: 'Decrease quantity', increase: 'Increase quantity' }
      : { quantity: 'الكمية', decrease: 'تقليل الكمية', increase: 'زيادة الكمية' };

    if (String(document.documentElement.lang).toLowerCase() === 'fr' && window.HVFrenchUI) {
      labels.quantity = window.HVFrenchUI.quantity;
      labels.decrease = window.HVFrenchUI.decreaseQuantity;
      labels.increase = window.HVFrenchUI.increaseQuantity;
    }

    document.querySelectorAll('input[name="quantity"]').forEach(function (input, index) {
      if (!input.getAttribute('aria-label')) input.setAttribute('aria-label', labels.quantity);
      if (!input.id) input.id = 'Quantity-auto-' + index;
    });

    document.querySelectorAll('.quantity button, .selector-row .quantity button').forEach(function (button) {
      const text = button.textContent.trim();
      if (!button.getAttribute('aria-label')) {
        if (text === '-' || text === '−') button.setAttribute('aria-label', labels.decrease);
        if (text === '+') button.setAttribute('aria-label', labels.increase);
      }
    });
  }

  applyQuantityAccessibility();
  document.addEventListener('DOMContentLoaded', applyQuantityAccessibility);
  document.addEventListener('shopify:section:load', applyQuantityAccessibility);
  new MutationObserver(applyQuantityAccessibility).observe(document.body, { childList: true, subtree: true });
})();

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape' && (document.body.classList.contains('mobile-open') || document.documentElement.classList.contains('mobile-open'))) {
    document.body.classList.remove('mobile-open');
    document.documentElement.classList.remove('mobile-open');
    const drawer = document.querySelector('.hv2-mobile-drawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    document.querySelectorAll('[data-mobile-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
  }
});

(function () {
  function initSlideshow(slideshow) {
    if (!slideshow || slideshow.dataset.hvSlideshowReady === 'true') return;
    const slides = Array.prototype.slice.call(slideshow.querySelectorAll('[data-hv-slide]'));
    if (!slides.length) return;
    slideshow.dataset.hvSlideshowReady = 'true';
    const dots = Array.prototype.slice.call(slideshow.querySelectorAll('[data-hv-slider-dot]'));
    const previous = slideshow.querySelector('[data-hv-slider-prev]');
    const next = slideshow.querySelector('[data-hv-slider-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    let delay = parseInt(slideshow.dataset.delay || '5000', 10);
    let index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    let timer = null;
    if (!Number.isFinite(delay) || delay < 2500) delay = 5000;

    function show(target) {
      index = (target + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, dotIndex) {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (autoplay && slides.length >= 2) timer = window.setInterval(function () { show(index + 1); }, delay);
    }

    if (previous) previous.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        const target = parseInt(dot.dataset.hvSliderDot || '0', 10);
        if (Number.isFinite(target)) { show(target); start(); }
      });
    });
    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);
    slideshow.addEventListener('focusin', stop);
    slideshow.addEventListener('focusout', start);
    show(index);
    ('requestIdleCallback' in window ? requestIdleCallback : function (callback) { window.addEventListener('load', callback, { once: true }); })(start);
  }

  function initAll(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-hv-slideshow]')).forEach(initSlideshow);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();

(function () {
  function initReviews(root) {
    const scope = root || document;
    Array.prototype.slice.call(scope.querySelectorAll('[data-hv-reviews]')).forEach(function (reviews) {
      if (reviews.dataset.hvReviewsReady === 'true') return;
      reviews.dataset.hvReviewsReady = 'true';
      const button = reviews.querySelector('[data-hv-reviews-more]');
      if (!button) return;
      button.addEventListener('click', function () {
        const hidden = Array.prototype.slice.call(reviews.querySelectorAll('[data-hv-review-card].is-hidden'));
        hidden.slice(0, 6).forEach(function (card) { card.classList.remove('is-hidden'); });
        if (!reviews.querySelector('[data-hv-review-card].is-hidden')) button.hidden = true;
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initReviews(document); });
  else initReviews(document);
  document.addEventListener('shopify:section:load', function (event) { initReviews(event.target); });
})();

(function () {
  function storageAvailable() {
    try {
      const key = 'hv-bundle-popup-test';
      window.sessionStorage.setItem(key, '1');
      window.sessionStorage.removeItem(key);
      return true;
    } catch (error) { return false; }
  }

  const canStore = storageAvailable();
  let timers = [];

  function storageKey(element) {
    if (!element) return '';
    const section = element.closest('[data-hv-bundle-section]');
    return section ? section.getAttribute('data-hv-bundle-storage-key') : '';
  }

  function wasShown(section) {
    if (!canStore || !section) return false;
    const key = section.getAttribute('data-hv-bundle-storage-key');
    return key ? window.sessionStorage.getItem(key) !== null : false;
  }

  function markShown(section) {
    if (!canStore || !section) return;
    const key = section.getAttribute('data-hv-bundle-storage-key');
    if (key) window.sessionStorage.setItem(key, 'shown');
  }

  function markDismissed(element) {
    if (!canStore || !element) return;
    const key = storageKey(element);
    if (key) window.sessionStorage.setItem(key, 'dismissed');
  }

  function formatCountdown(seconds) {
    const value = Math.max(0, seconds || 0);
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value % 3600) / 60);
    const secs = value % 60;
    return [hours, minutes, secs].map(function (part) { return String(part).padStart(2, '0'); }).join(' : ');
  }

  function initCountdown(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-hv-bundle-section][data-hv-bundle-countdown-seconds]');
    sections.forEach(function (section) {
      if (section.dataset.hvBundleCountdownInit === 'true') return;
      const target = section.querySelector('[data-hv-bundle-countdown-timer]');
      if (!target) return;
      let seconds = parseInt(section.getAttribute('data-hv-bundle-countdown-seconds'), 10);
      if (isNaN(seconds) || seconds < 0) seconds = 0;
      let remaining = seconds;
      target.textContent = formatCountdown(remaining);
      section.dataset.hvBundleCountdownInit = 'true';
      const timer = window.setInterval(function () {
        if (!document.body.contains(section)) { window.clearInterval(timer); return; }
        remaining -= 1;
        if (remaining <= 0) {
          remaining = 0;
          target.textContent = formatCountdown(remaining);
          window.clearInterval(timer);
          return;
        }
        target.textContent = formatCountdown(remaining);
      }, 1000);
      timers.push(timer);
    });
  }

  function sectionFor(trigger) {
    if (!trigger) return null;
    let section = trigger.closest('[data-hv-bundle-section]');
    if (section) return section;
    const controls = trigger.getAttribute('aria-controls');
    if (controls) {
      const modal = document.getElementById(controls);
      if (modal) {
        section = modal.closest('[data-hv-bundle-section]');
        if (section) return section;
      }
    }
    const fallback = document.querySelector('[data-hv-bundle-section] [data-hv-bundle-modal]');
    return fallback ? fallback.closest('[data-hv-bundle-section]') : null;
  }

  function openModal(trigger, options) {
    if (!trigger) return;
    const section = sectionFor(trigger);
    if (!section) return;
    const modal = section.querySelector('[data-hv-bundle-modal]');
    if (!modal || modal.classList.contains('is-open')) return;
    if (!trigger.getAttribute('aria-controls') && modal.id) trigger.setAttribute('aria-controls', modal.id);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('hv-bundle-popup-open');
    if (options && options.markShown === true) markShown(section);
    if (!options || options.focusClose !== false) {
      const close = modal.querySelector('[data-hv-bundle-close]');
      if (close) close.focus();
    }
  }

  function closeModal(modal, options) {
    if (!modal) return;
    if (!options || options.markDismissed !== false) markDismissed(modal);
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hv-bundle-popup-open');
    const id = modal.getAttribute('id');
    if (!id) return;
    const triggers = document.querySelectorAll('[data-hv-bundle-open][aria-controls="' + id + '"]');
    triggers.forEach(function (trigger, index) {
      trigger.setAttribute('aria-expanded', 'false');
      if (index === 0 && (!options || options.restoreFocus !== false)) trigger.focus();
    });
  }

  function scheduleAutoOpen(root) {
    const scope = root || document;
    const sections = scope.querySelectorAll('[data-hv-bundle-section][data-hv-bundle-auto-open="true"]');
    sections.forEach(function (section) {
      if (section.dataset.hvBundleAutoScheduled === 'true' || section.classList.contains('hv-bundle-section--inline') || wasShown(section)) return;
      const trigger = section.querySelector('[data-hv-bundle-open]');
      const modal = section.querySelector('[data-hv-bundle-modal]');
      if (!trigger || !modal) return;
      section.dataset.hvBundleAutoScheduled = 'true';
      let delay = parseInt(section.getAttribute('data-hv-bundle-auto-delay'), 10);
      if (isNaN(delay) || delay < 0) delay = 5000;
      window.setTimeout(function () {
        if (document.body.contains(section) && !wasShown(section) && !document.querySelector('[data-hv-bundle-modal].is-open')) {
          openModal(trigger, { focusClose: false, markShown: true });
        }
      }, delay);
    });
  }

  function init(root) {
    initCountdown(root || document);
    scheduleAutoOpen(root || document);
  }

  document.addEventListener('click', function (event) {
    const open = event.target.closest('[data-hv-bundle-open]');
    if (open) { event.preventDefault(); openModal(open); return; }
    const close = event.target.closest('[data-hv-bundle-close]');
    if (close) { event.preventDefault(); closeModal(close.closest('[data-hv-bundle-modal]')); }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const modal = document.querySelector('[data-hv-bundle-modal].is-open');
      if (modal) closeModal(modal);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function () {
    timers.forEach(function (timer) { window.clearInterval(timer); });
    timers = [];
  });
})();

